import { formatDate } from '../lib/format'

/**
 * Полоска конвейера заявки.
 *
 * Клиент спрашивает не «в работе ли», а «на каком шаге»: коды ещё заказываются
 * или этикетки уже готовы. Полоска отвечает на это с одного взгляда — и у
 * клиента в кабинете, и у нас в карточке.
 *
 * Пройденные шаги подписаны датой: «когда вы заказали карточки» — второй по
 * частоте вопрос после «когда будет готово».
 */
export interface StageStepView {
  stage: string
  title: string
  done: boolean
  current: boolean
  at: string | null
}

export default function StageBar({
  steps,
  dueOn,
  overdue,
}: {
  steps: StageStepView[]
  dueOn?: string | null
  overdue?: boolean
}) {
  if (steps.length === 0) return null

  return (
    <div className="stages">
      <div className="stages-row">
        {steps.map((s) => (
          <div
            key={s.stage}
            className={`stage${s.done ? ' done' : ''}${s.current ? ' current' : ''}`}
            title={s.at ? formatDate(s.at) : undefined}
          >
            <span className="stage-dot" />
            <span className="stage-title">{s.title}</span>
            {s.at && <span className="stage-at">{formatDate(s.at)}</span>}
          </div>
        ))}
      </div>
      {dueOn && (
        <div className={overdue ? 'stages-due overdue' : 'stages-due'}>
          {overdue ? 'Срок прошёл: ' : 'Ожидаемый срок: '}
          {formatDate(dueOn)}
        </div>
      )}
    </div>
  )
}
